const Styles = {
    boxContainer: {
        p:2,
        bgcolor:'#fff',
        height:'100vh'
    }
}

export default Styles;